import { useState, useEffect, PropsWithChildren } from "react";
import { useQuery } from "@apollo/client";
import { USER_FEATURE_FLAG_QUERY } from "./queries";
import { initializeFeatures, FlagRecord, FeatureFlagContext } from "@/hooks/useFeatureFlags";

const FeatureFlagProvider = ({ children }: PropsWithChildren<{}>) => {
  const [featureFlags, setFeatureFlags] = useState<FlagRecord>({});
  const [loaded, setLoaded] = useState(false);
  const { data, loading } = useQuery(USER_FEATURE_FLAG_QUERY);

  useEffect(() => {
    if (loading) {
      return;
    }

    if (!data) {
      setLoaded(true);
      return;
    }

    let cancelled = false;

    const fetchFeatureFlags = async () => {
      try {
        const flags = await initializeFeatures(data.me);

        if (!cancelled && flags) {
          setFeatureFlags(flags);
        }
      } finally {
        if (!cancelled) {
          setLoaded(true);
        }
      }
    };

    fetchFeatureFlags();

    return () => {
      cancelled = true;
    };
  }, [data, loading]);

  return <FeatureFlagContext.Provider value={{ flags: featureFlags, loaded }}>{children}</FeatureFlagContext.Provider>;
};

export default FeatureFlagProvider;
